const flat = "flat";
const concave = "concave";
const convex = "convex";
const inset = "inset";

export const type = {
  flat,
  concave,
  convex,
  inset,
};
